<template>
  <div id="app">
    <router-view v-if="bootstrapped && (userId || isLoginRoute)" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { loginByDingTalk, isInDingTalk } from "@/utils/login";
import { getToken } from "@/utils/auth";
export default {
  name: "App",
  data() {
    return {
      bootstrapped: false,
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters(["agentId", "corpId", "userId"]),
    isLoginRoute() {
      return this.$route && this.$route.path === '/login';
    },
  },
  methods: {
    init() {
      if (isInDingTalk()) {
        this.initDingTalkLogin();
      } else {
        this.initPasswordLogin();
      }
    },
    initPasswordLogin() {
      this.bootstrapped = true;
      const hasToken = !!getToken();
      if (hasToken && !this.userId) {
        this.$store.commit('user/SET_TOKEN', '');
      }
      if (!getToken()) {
        if (this.$route.path !== '/login') {
          this.$router.replace({
            path: '/login',
            query: { redirect: this.$route.fullPath },
          });
        }
        return;
      }
      this.$store.dispatch('user/changeMenus');
    },
    initDingTalkLogin() {
      if (this.agentId && this.corpId) {
        this.getDDConfig();
        return;
      }
      this.$http.post("/biz/getDingSecretKey").then((res) => {
        if (res.success) {
          this.$store.commit("demo/SET_AGENTID", String(res.data.agentId));
          this.$store.commit("demo/SET_CORPID", String(res.data.corpId));
          this.getDDConfig();
        } else {
          this.$message({ type: "error", message: "获取钉钉配置失败" });
          this.bootstrapped = true;
        }
      }).catch(() => {
        this.$message({ type: "error", message: "获取钉钉配置失败" });
        this.bootstrapped = true;
      });
    },
    getDDConfig() {
      let self = this;
      this.$http
        .post("/biz/getJsApiAuth", {
          url: encodeURI(
            window.location.href.substring(0, window.location.href.indexOf("#"))
          ),
        })
        .then((res) => {
          this.$dd.config({
            agentId: this.agentId,
            corpId: this.corpId,
            timeStamp: res.data.timeStamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            type: 0,
            jsApiList: ["runtime.info", "biz.contact.choose"],
          });
          this.$dd.error(function (err) {
            let errStr = JSON.stringify(err);
            if (errStr === '{}') {
              self.$message({
                type: "error",
                message: "此应用需要在钉钉内打开，请设置：钉钉客户端-设置-工作台内应用的所有页面都在钉钉内打开",
              });
            } else {
              alert("dd error: " + errStr);
            }
          });
          loginByDingTalk(() => {
            self.bootstrapped = true;
          });
        })
        .catch((err) => {
          console.log("AutoConsole: getDDConfig -> err", err);
          self.$message({ type: "error", message: "钉钉登录失败" });
          self.bootstrapped = true;
        });
    },
  },
};
</script>
